import { Pages, Roles } from '../../context/contexts/UserContext/permissionsTypes';
import useHasPermissions from '../../hooks/useHasPermissions';
import { LogicalRoute, LogicalRouteImportProps } from '../helpers/LogicalRoute';
import ApplicationDiscovery from '../../components/ApplicationsDiscovery/ApplicationsDiscovery';

export const ApplicationsDiscoveryRouting = (props: LogicalRouteImportProps) => {
    const disabled = !useHasPermissions({ permission: Pages.APPLICATIONS_DISCOVERY, role: Roles.VIEWER });
    return <LogicalRoute {...props} component={ApplicationDiscovery} disabled={disabled} />;
};
